import React from "react";
import ERROR_IMAGE from "assets/images/generic-error-transparent.png";

const GenericError = () => {
  return (
    <img
      alt="generic error"
      src={ERROR_IMAGE}
      style={{
        objectFit: "contain",
        maxWidth: "100%",
        maxHeight: "100%",
        borderRadius: "2%",
      }}
    />
  );
};

export default GenericError;
